$(function() {

    //Wrap Umbraco checkboxes in a wrapper to improve checkbox styling
    $(".umbraco-forms-field.checkbox").find("> .umbraco-forms-field-wrapper, > input[type=checkbox]").wrap("<div class='umbraco__checkbox__wrapper'></div>");
    let tooltip = $(".umbraco-forms-field.checkbox").find(".umbraco-forms-tooltip");
    $(".umbraco-forms-field.checkbox .umbraco-forms-tooltip").remove();
    $(".umbraco-forms-field.checkbox .umbraco__checkbox__wrapper").append(tooltip);
    $(".umbraco-forms-field.checkbox .umbraco-forms-field-wrapper").removeClass("umbraco-forms-field-wrapper").addClass("checkbox__wrapper");
    $(".umbraco-forms-field.checkbox .umbraco__checkbox__wrapper > input[type=checkbox]").wrap("<div class='checkbox__wrapper'></div>")

    if ($(".umbraco-forms-field.checkbox").find(".umbraco-forms-tooltip").length) {
        $(".umbraco__checkbox__wrapper").addClass("full-width")
    }

    //Umbraco form submit
    var newsletterInputWrapper = $("footer .umbraco-forms-field-wrapper");
    newsletterInputWrapper.find("input[type=text]").wrap("<div class='newsletter__input__wrapper'></div>")
    newsletterInputWrapper.find(".newsletter__input__wrapper").append("<button type='submit' vaue='' name='__next' class='newsletter-submit'>Submit</button>")    
})